module.exports = __webpack_public_path__ + "static/media/Rectangle 188.fc001637.svg";